import type { ReactNode } from 'react';
import cx from 'clsx';

interface Props {
  children: ReactNode;
  hasCtaButton?: boolean;
  hasStickyBar?: boolean;
}

export const FloatingWrapper = ({
  children,
  hasCtaButton = false,
  hasStickyBar = false,
}: Props) => {
  return (
    <div
      id="floatingWrapper"
      className={cx(
        'pointer-events-none disable-text-size-adjust fixed z-10 flex w-full max-w-3xl flex-col items-end',
        '[&>*:first-child]:pointer-events-auto [&>*:first-child]:mb-12 [&>*:first-child]:mr-16 [&>a]:!m-0',
        hasStickyBar
          ? 'bottom-0'
          : 'bottom-[calc(var(--ios-safe-bottom)_+_20px)]',
        hasStickyBar && 'mb-0',
        !hasStickyBar &&
          hasCtaButton &&
          'mb-[calc(100px_-_var(--ios-safe-bottom))]',
      )}
    >
      {children}
    </div>
  );
};
